import { Tooltip, Typography } from '@mui/material';
import { useModelCostControllerEstimateQuery } from '@shared/services/apiService';

export const ProfileCostEstimate = ({
  companyId,
  agentId,
}: {
  companyId: string;
  agentId: string;
}) => {
  const { currentData: data, isError } = useModelCostControllerEstimateQuery(
    { companyId, agentId },
    {
      skip: !companyId || !agentId || agentId === 'new',
      refetchOnMountOrArgChange: true,
      pollingInterval: 60000,
      skipPollingIfUnfocused: true,
    },
  );
  const label = isError
    ? 'Usage estimate unavailable'
    : !data
      ? 'Calculating usage estimate…'
      : data.state === 'available'
        ? `Estimated usage: ~${data.creditsPerMinute} credits/min`
        : data.state === 'no_history'
          ? 'Estimate available after first calls'
          : 'Usage estimate unavailable';
  return (
    <Tooltip
      title={
        data?.state === 'available'
          ? `Based on ${data.sampleCount} matching calls in the last ${data.windowDays} days, at current pricing. For the saved configuration. Actual usage varies. Calculated ${new Date(data.calculatedAt).toLocaleString()}.`
          : (data?.reason ?? 'Actual usage varies with model activity and conversation length.')
      }>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Tooltip>
  );
};
